/**
 * @file labao模块路由导出
 */
import reportingCenter from './reporting-center';
import login from './login';
import accident from './accident';
import claim from './claim';
import claimApply from './claim-apply';
import transitPage from './transit-page';
import cargoTreasure from './cargo-treasure'; // 拉货宝权益领取

export default [
  ...reportingCenter,
  ...login,
  ...accident,
  ...claim,
  ...claimApply,
  ...transitPage,
  ...cargoTreasure
];
